import WarningIcon from './WarningIcon'

export default WarningIcon
